<template>
  <div>
    <div v-if="summary">
      <mdb-tbl hover sm>
        <mdb-tbl-head>
          <tr class="title" >
            <th>학생명</th>
            <th style="width:90px">수행1</th><th style="width:90px">수행2</th>
            <th style="width:90px">필답1</th><th style="width:90px">필답2</th>
            <th style="width:90px">태도</th>
            <th style="width:90px">포트폴리오</th>
          </tr>
        </mdb-tbl-head>
        <mdb-tbl-body>
          <tr v-for="(s, ix) in summary" :key="ix">
            <td>{{s.name}}</td>
            <td><staff-test-result  :result="s.perform[1]"
                @view-result="onViewPerformResult(s.perform[1])"/></td>
            <td><staff-test-result  v-if="isRetry(s.perform[1].score)" :result="s.perform[2]"
                @view-result="onViewPerformResult(s.perform[2])"/></td>
            <td>
              <staff-test-result  :result="s.writing[1]"
                @view-result="onViewWritingResult(s.writing[1])"/></td>
            <td><staff-test-result  v-if="isRetry(s.writing[1].score)" :result="s.writing[2]"
                @view-result="onViewWritingResult(s.writing[2])"/></td>
            <td>
              <staff-test-result  :result="s.attitude" :attitude="true"
                @view-result="onViewAttitudeResult(s.attitude, s._id)"/>
            </td>
            <td><staff-test-result  :result="s.portfolio"
                @view-result="onViewPortfolioResult(s.portfolio)"/></td>
          </tr>
        </mdb-tbl-body>
      </mdb-tbl>
    </div>
  </div>
</template>
<script>
import { mdbIcon, mdbBtn } from 'mdbvue';
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import Summary from '@/models/Summary'
import StaffTestResult from './StaffTestResult.vue';
export default {
  components: { StaffTestResult },
  name: 'StaffTestSummaryPerSubject',
  props: [],
  computed: {
    ...mapState('training', ['training']),
    ...mapGetters('training', ['failScore']),
    query () {
      return this.$route.query
    }
  },
  data () {
    return {
      summary: undefined // 결과 요약 데이터
    }
  },
  methods: {
    // 재시험 대상인지 여부
    isRetry (score) {
      return score && score < this.failScore
    },
    async load () {
      const training = this.training._id
      const { subject, lecture, code } = this.$route.query
      if (training && subject) {
        const _code = code || subject
        this.summary = await Summary.getBySubject(training, subject, lecture, _code)
      }
    },
    color (score) {
      if (!score) return
      return score < this.failScore ? 'danger' : 'success'
    },
    onViewPerformResult (info) {
      const { test, answer } = info
      this.$router.push({
        name: 'StaffPerformTestView',
        query: { test, answer }
      })
    },
    onViewWritingResult (info) {
      const { test, answer } = info
      this.$router.push({
        name: 'StaffWritingTestView',
        query: { test, answer }
      })
    },
    onViewAttitudeResult (info, student) {
      const { test, answer } = info
      this.$router.push({
        name: 'StaffAttitudeTestView',
        query: { test, answer, student }
      })
    },
    onViewPortfolioResult (info) {
      const { test, answer } = info
      this.$router.push({
        name: 'StaffPortfolioTestView',
        query: { test, answer }
      })
    }
  },
  watch: {
    query () { this.load() },
    training () { this.load() }
  },
  created () { this.load() }
}
</script>
